import { kebabCase } from "lodash";

function dynamicComponent($compile, $injector) {
	this.compile = compile;

	function compile(
		settings,
		locals,
		scope,
		hostElement,
		context
	) {
		const bindings = $injector.invoke(settings.resolve, context, locals);

		// get "simple" properties
		const defaultProps = Object.keys(settings.props || {})
			.map(key => `${kebabCase(key)}="${settings.props[key]}"`)
			.join(" ");

		// resolve component "bindings"
		// join with properties
		const props = Object.keys(bindings)
			.map(key => `${kebabCase(key)}="${key}"`)
			.concat(defaultProps)
			.join(" ");

		// add component binding values to corresponding scope
		scope = Object.keys(bindings).reduce((acc, key) => {
			acc[key] = bindings[key];
			return acc;
		}, scope);

		const html = `<${settings.component} ${props}></${settings.component}>`;
		const el = angular.element(html);

		hostElement.empty().append(el);

		$compile(el)(scope);
	}
}

export default angular
	.module("vesl.services.dynamic-component", [])
	.service("dynamicComponent", dynamicComponent).name;
